// Supports weights 200-800
import '@fontsource-variable/oxanium';

import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import WebApp from '@twa-dev/sdk';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import NotFound from '@/pages/404';

import './App.css';
import './index.css';

WebApp.ready();

WebApp.setBackgroundColor('#180C23');
WebApp.setHeaderColor('#180C23');

Sentry.init({
  dsn: 'https://a42997ad7a04f5233c7ee04fb84714b9@sentry.portal.ethsign.xyz/9',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

const router = createBrowserRouter([
  {
    path: '/',
    async lazy() {
      const Page = await import('@/pages/home');
      return { Component: Page.default };
    }
  },
  {
    path: '/suspended-account',
    async lazy() {
      const Page = await import('@/pages/SuspendedAccount');
      return { Component: Page.default };
    }
  },

  {
    path: '/reward-station',
    children: [
      {
        path: 'wayfinder',
        async lazy() {
          const Page = await import('@/pages/wayfinder');
          return { Component: Page.default };
        }
      },
      {
        path: 'huma',
        async lazy() {
          const Page = await import('@/pages/huma');
          return { Component: Page.default };
        }
      },
      {
        path: 'skate',
        async lazy() {
          const Page = await import('@/pages/skate');
          return { Component: Page.default };
        }
      },
      {
        path: 'skate-2',
        async lazy() {
          const Page = await import('@/pages/skate/skate2');
          return { Component: Page.default };
        }
      },
      {
        path: 'newton',
        async lazy() {
          const Page = await import('@/pages/newton');
          return { Component: Page.default };
        }
      },
      {
        path: 'arb',
        async lazy() {
          const Page = await import('@/pages/arb');
          return { Component: Page.default };
        }
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
